import React from "react";
import PropTypes from "prop-types";

import ExpressionBuilderFromModel from "./ExpressionBuilderFromModel";
import App from "../app";

export default class ExpressionBuilder extends React.Component {
  static propTypes = {
    features:         PropTypes.object,
    name:             PropTypes.string.isRequired,
    expressionText:   PropTypes.string.isRequired,
    description:      PropTypes.string,
    expressionNodes:  PropTypes.array,
    terminalMetaData: PropTypes.object.isRequired,
    selectValues:     PropTypes.object,
    selectUrls:       PropTypes.object,
    editable:         PropTypes.bool,
    showToggle:       PropTypes.bool,
    onChange:         PropTypes.func,
    onValidate:       PropTypes.func
  };

  static defaultProps = {
    features:        {},
    selectValues:    {},
    selectUrls:      {},
    editable:        true,
    showToggle:      true,
    expressionText:  "",
    expressionNodes: [],
    onChange:        () => {},
    onValidate:      () => Promise.resolve()
  };

  constructor(props) {
    super(props);

    this.state = {
      errorText:   "",
      warningText: ""
    };

    const { expressionText, expressionNodes, name, terminalMetaData, onValidate } = this.props;

    this.expression = new App.Models.ExpressionOwner({ expression: expressionText, name: name }, { terminalMetaData });

    // Validations are handled via 'validate' triggers that callback to _fetchExpressionOwner
    this.expression._fetchExpressionOwner = (errorCallback) => {
      onValidate(this.expression.get('expression'))
        .then((response) => this.expression._processSuccessfulExpressionSync(response))
        .catch((errorResponse) => this.expression._processExpressionSyncWithErrors(errorResponse, errorCallback))
        .finally(() => this.expression.trigger('validating:false'));
    };

    // Changes (not necessarily validations) are handled via these listeners.
    this.expression.on("change:expression", this.propagateOnExpressionTextChange);
    this.expression.expressionTerminals.on("change add remove reset", this.propagateOnExpressionTerminalsChange);

    // TODO: Non-ideal way to bind errors and warnings to UI fields. Clean this up later
    this.expression.on("change:errors", this.onExpressionErrorsChange);
    this.expression.on("change:warnings", this.onExpressionWarningsChange);

    if (expressionNodes && expressionNodes.length > 0) {
      this.expression._processSuccessfulExpressionSync({ expression_nodes: expressionNodes });
    }
  }

  propagateOnExpressionTextChange = (model, expressionText) => {
    const event = {
      target: {
        name:            this.props.name,
        expressionText:  expressionText,
        expressionNodes: model.expressionTerminals.expressionNodes()
      }
    };
    this.props.onChange(event);
  }

  propagateOnExpressionTerminalsChange = () => {
    const event = {
      target: {
        name:            this.props.name,
        expressionText:  this.expression.expressionTerminals.expressionText(),
        expressionNodes: this.expression.expressionTerminals.expressionNodes()
      }
    };
    this.props.onChange(event);
  }

  onExpressionErrorsChange = (expressionModel, errors) => {
    // Only set state on actual values so you don't cause a refresh loop.
    if (errors && errors.expression) {
      this.setState({ errorText: errors.expression });
    } else if (expressionModel.previousAttributes().errors && expressionModel.previousAttributes().errors.expression) {
      this.setState({ errorText: "" });
    }
  }

  onExpressionWarningsChange = (expressionModel, warnings) => {
    // Only set state on actual values so you don't cause a refresh loop.
    if (warnings && warnings.expression) {
      this.setState({ warningText: warnings.expression });
    } else if (expressionModel.previousAttributes().warnings && expressionModel.previousAttributes().warnings.expression) {
      this.setState({ warningText: "" });
    }
  }

  render() {
    const { editable, showToggle, ...builderProps } = this.props;

    return (
      <ExpressionBuilderFromModel
        model={this.expression}
        setup={{ editable, showToggle }}
        errorText={this.state.errorText}
        warningText={this.state.warningText}
        {...builderProps}
      />
    );
  }
}
